import { wpFetch } from 'src/helpers/wpApiHandler';

const useGetAllRecruiters = async (companyId) => {
  const response = await wpFetch(['recruiters', companyId], {
    method: 'GET',
  });

  return response;
};

export default useGetAllRecruiters;
